import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandSearchComponent } from '../brand-search/brand-search.component';

@Component({
  selector: 'app-trial-step-two',
  standalone: true,
  imports: [CommonModule, BrandSearchComponent],
  templateUrl: './trial-step-two.component.html',
  styleUrl: './trial-step-two.component.scss',
})
export class TrialStepTwoComponent implements OnInit {
  @Input() firstName = '';
  @Output() nextStep = new EventEmitter<void>();

  displayFirstName = '';

  ngOnInit(): void {
    this.displayFirstName = this.firstName || '';
  }

  onNext(): void {
    this.nextStep.emit();
  }
}
